module.exports = __webpack_public_path__ + "img/requisites.bae2707.jpg";